import { render, staticRenderFns } from "./QuestionContent.vue?vue&type=template&id=579cc587&"
import script from "./QuestionContent.vue?vue&type=script&lang=js&"
export * from "./QuestionContent.vue?vue&type=script&lang=js&"
import style0 from "./QuestionContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports